module.exports = __webpack_public_path__ + "static/media/0.5576c059.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/0.png
// module id = 1446
// module chunks = 0